import { render, staticRenderFns } from "./CustomFilter.vue?vue&type=template&id=155f63bf&scoped=true&"
import script from "./CustomFilter.vue?vue&type=script&lang=js&"
export * from "./CustomFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomFilter.vue?vue&type=style&index=0&id=155f63bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f63bf",
  null
  
)

export default component.exports